module.exports = __webpack_public_path__ + "img/744.963e65c6.jpg";